import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/logo.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Function to check if link is active
  const isLinkActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname === path;
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  // Toggle menu and body scroll
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle('menu-open');
  };

  // Close menu when clicking a link
  const handleLinkClick = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${!isHomePage ? 'not-home' : ''}`}>
      <div className="navbar-container">
        <div className="logo">
          <img src={logo} alt="House of Canvas Logo" />
        </div>
        <button 
          className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <a 
              href="/" 
              className={isLinkActive('/') ? 'current-page' : ''} 
              onClick={handleLinkClick}
            >
              Home
            </a>
          </li>
          <li>
            <a 
              href="/who-we-are" 
              className={isLinkActive('/who-we-are') ? 'current-page' : ''} 
              onClick={handleLinkClick}
            >
              Who We Are
            </a>
          </li>
          <li>
            <a 
              href="/what-we-do" 
              className={isLinkActive('/what-we-do') ? 'current-page' : ''} 
              onClick={handleLinkClick}
            >
              What We Do
            </a>
          </li>
          <li><a href="#products" onClick={handleLinkClick}>Products</a></li>
          <li><a href="#gallery" onClick={handleLinkClick}>Gallery</a></li>
          <li><a href="/faq" onClick={handleLinkClick}>FAQs</a></li>
          <li><a href="/contact" onClick={handleLinkClick}>Contact Us</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 